import { useAuth } from "@/hooks/useAuth";

/**
 * Hook to check if the current user has Super Admin role
 */
export function useSuperAdmin() {
  const { roles, isLoading } = useAuth();
  
  const isSuperAdmin = roles.some(r => r.role === "super_admin");
  
  return {
    isSuperAdmin,
    isLoading,
  };
}
